
import {getCreditHisotry} from '../api/getCreditHisotry';
import {setGetCreditHistoryAction} from '../action';
import { setLoadingAction } from '../../../components/templatePage/store/action';

const setGetCreditHisotry = (params) => {
    return async (dispatch, getState) => {
        try {
            const {data} = await getCreditHisotry(params);

            if (data.status === 'success') {
                const list = [...getState().creditMobile.history.list];

                list.push(data.list);
                dispatch(setGetCreditHistoryAction({
                    list: list.flat(1),
                    page: data.countPage
                }));           
                dispatch(setLoadingAction(false))
            }
          
        } catch(error) {
            if (error && error.response && error.response.status === 401) {
                localStorage.removeItem('token');
                window.location.replace(window.location.origin);
            }
        }
    }
}

export {
    setGetCreditHisotry
}